import {
  AccessDeniedError,
  ApiError,
  BusinessRuleError,
  InfraError,
  LoginError,
  NetworkError,
  NotFoundError,
  ValidationError,
} from "@/domain/errors";
import { SessionClient } from "@/domain/clients";
import { ApiResponse } from "@/infra/api/ApiResponse";
import { AxiosError } from "axios";

export const createErrorInterceptor = (sessionClient: SessionClient) => {
  return (error: AxiosError) => {
    if (!error.response) {
      return Promise.reject(new NetworkError());
    }

    if (!error.request) {
      return Promise.reject(new Error("Erro de requisição"));
    }

    const status: number = error.response.status;
    const data = error.response.data as ApiResponse;
    const message: string = data.message || "";

    // console.error(
    //   "ERRO:",
    //   JSON.stringify(
    //     {
    //       status,
    //       data,
    //       message,
    //     },
    //     null,
    //     4,
    //   ),
    // );

    switch (status) {
      case 400:
        return Promise.reject(new ValidationError(message));
      case 401:
        // Destrói a sessão (callback de navegação será executado automaticamente)
        sessionClient.destroySession();
        // if (error.config && error.config.url !== Endpoints.login) {
        //   sessionService.redirectToLogin();
        // }
        return Promise.reject(new LoginError());
      case 403:
        return Promise.reject(new AccessDeniedError());
      case 404:
        return Promise.reject(new NotFoundError());
      case 422:
        return Promise.reject(new BusinessRuleError(message));
      case 500:
        return Promise.reject(new InfraError(message));
      default:
        return Promise.reject(new ApiError(message));
    }
  };
};
